import SublevelCard from "@@/components/Card/Sublevel";
import Box from "@@/elements/Box";
import Container from "@@/elements/Container";
import { LinkData } from "@@/models/linkdata";
import { PictureData } from "@@/models/pictureData";
import styles from "../cardContainer.module.scss";
import { BackgroundColor, colorMapper } from "../description";

type HitItem = {
  publishdate: string;
  header: string;
  intro: string;
  image: PictureData;
  link: LinkData;
  categories: string[];
};

type SearchResponseType = {
  items: HitItem[];
  totalMatching: number;
};

export type SublevelListingProps = {
  searchResponse: SearchResponseType;
  backgroundColor: BackgroundColor;
};

const SublevelListingContainer = ({
  searchResponse,
  backgroundColor,
}: SublevelListingProps) => {
  if (!searchResponse?.items?.length) {
    return null;
  }

  return (
    <Box mt={18} backgroundColor={colorMapper(backgroundColor)}>
      <Container
        className={styles.sublevel_container}
        pageGutterX={0}
        size="xlarge"
      >
        <Box className={styles.grid_sublevel}>
          {searchResponse.items.map((card) => (
            <SublevelCard
              header={card.header}
              image={card.image}
              intro={card.intro}
              link={card.link}
              backgroundColor={backgroundColor}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default SublevelListingContainer;
